/*
FILTER (MIXITUP)
*/

import mixitup from 'mixitup';
import mixitupMultifilter from './multifilter.js';

mixitup.use(mixitupMultifilter);

const mixitupContainer = document.querySelector('.seminar-overview__teasers');

if (mixitupContainer) {

    // mark events that are over for initial filtering
    setDataIsOverAttributes();

    let mixer = mixitup(mixitupContainer, {
        selectors: {
            target: '.seminar-teaser'
        },
        multifilter: {
            enable: true
        }
    });
}



/*
ACTIVE FILTERS
*/


const activeFiltersWrapper = document.querySelector('.seminar-filter__selected-filters');

[...document.querySelectorAll('[data-toggle]:not(#not-over-filter-button)')].forEach(filterToggleEl => {
    filterToggleEl.addEventListener('click', () => {

        const filterToggleElIsActive = filterToggleEl.classList.contains('mixitup-control-active');
        const label = filterToggleEl.getAttribute('data-label') || filterToggleEl.querySelector('span').innerHTML;
        const activeFilterDropdown = filterToggleEl.closest('.seminar-filters__dropdown, .seminar-filters__radio-wrapper').querySelector('.seminar-filters__dropdown-box, .seminar-filters__radio');    
        const activeFiltersWrapperCount = filterToggleEl.closest('.seminar-filters__filter').querySelector('.seminar-filter__selected-count');
        const activeFilterDropdownCount = activeFilterDropdown.closest('.seminar-filters__dropdown, .seminar-filters__radio-wrapper').querySelectorAll('[data-toggle].mixitup-control-active').length;


        if (!filterToggleElIsActive) {
            // this filter is being activated
            const newElementHtml = createSelectedFilterItem(label);
            activeFiltersWrapper.innerHTML += newElementHtml;
            createEventListenersForCloseButtons();
            
            if (activeFilterDropdown.classList.contains('seminar-filters__radio')) {
                activeFilterDropdown.classList.add('red-border');
            }

            if (activeFilterDropdown.classList.contains('seminar-filters__dropdown-box')) {
                const countNumber = createSelectedFilterCount(activeFilterDropdownCount+1);
                activeFiltersWrapperCount.innerHTML = countNumber;
            }
        }
        
        else {
            // this filter is being deactivated
           const elementToDelete = activeFiltersWrapper.querySelector('[data-label="' + label + '"]');
           elementToDelete.remove();

            if (activeFilterDropdown.classList.contains('seminar-filters__dropdown-box')) {
                const countNumber = createSelectedFilterCount(activeFilterDropdownCount-1);
                activeFiltersWrapperCount.innerHTML = countNumber;
                
                
                if (activeFilterDropdownCount == 1) {
                    activeFiltersWrapperCount.innerHTML = "";
                }
            }
            
            else {
                activeFilterDropdown.classList.remove('red-border');
            }
        }
        
    });
});

function createSelectedFilterItem(label) {
    return `<div class="selected-filter__item" data-label="` + label + `">
                <span class="selected-filter__item-titel">` + label + `</span>
                <div class="selected-filter__item-close"> </div>
            </div>`;
}

function createSelectedFilterCount(number) {
    return `<span class="selected-filter__count">` + number + `</span>`;
}


function createEventListenersForCloseButtons() {
    [...activeFiltersWrapper.querySelectorAll('.selected-filter__item')].forEach(el => {
        const closeBtn = el.querySelector('.selected-filter__item-close');
        const label = el.querySelector('.selected-filter__item-titel').innerHTML;
        const filterElement = getFilterElementFromLabel(label);

        closeBtn.addEventListener('click', () => {
            filterElement.click();
        });
    });
}

function getFilterElementFromLabel(label) {
    return document.querySelector('[data-toggle][data-label="' + label.toLowerCase() + '"]') ||
        document.querySelector('[data-toggle][data-label="' + label + '"]');
}



/*
MANAGE EVENTS THAT ARE OVER
(only show them when a date is selected)
*/

function setDataIsOverAttributes() {
    const teasers = document.querySelectorAll('.seminar-teaser');

    teasers.forEach(teaser => {
        // current day plus 22 hours for some buffer, so show events that are happening today
        // (x 1000 for nanosecond comparison)
        const timestamp = (parseInt(teaser.dataset.initialFilterTimestamp) + 79200) * 1000;

        if (timestamp < Date.now()) {
            // they would be hidden by the filter but with an animation,
            // so we are hiding them like this on page load.
            teaser.style.display = 'none';
        } else {
            // set the data attribute for filtering:
            teaser.setAttribute('data-not-over', 'true');
        }
    })
}

setTimeout(() => {
    // activate the data-not-over filter on page load:
    const notOverFilterButton = document.querySelector('#not-over-filter-button');

    // toggle the data-not-over filter if the date toggle changes:
    if (notOverFilterButton) {
        notOverFilterButton.click();
        
        [...document.querySelectorAll('[data-toggle*="data-date"]')].forEach(filterToggleEl => {
            filterToggleEl.addEventListener('click', () => {

                const filterToggleElIsActive = filterToggleEl.classList.contains('mixitup-control-active');
                const activeDateFilters = document.querySelectorAll('.mixitup-control-active[data-toggle*="data-date"]');

                const onlyMonthIsBeingActivated = activeDateFilters.length == 0 && !filterToggleElIsActive;
                const onlyMonthIsBeingDeactivated = activeDateFilters.length == 1 && filterToggleElIsActive;

                if (onlyMonthIsBeingActivated || onlyMonthIsBeingDeactivated) {
                    notOverFilterButton.click();
                }
                
            });
        });
    }
}, 200);



/*
CHANGE LABEL ON FILTER
*/

const buttonsToChangeLabel = document.querySelectorAll('.seminar-filters__choices [data-toggle]');
const multipleChosenLabelEl = document.querySelector('[data-multiple-filter-chosen-label]');
if (multipleChosenLabelEl) {
    const multipleChosenLabel = multipleChosenLabelEl.getAttribute('data-multiple-filter-chosen-label');

    [...buttonsToChangeLabel].forEach(btn => {
    btn.addEventListener('click', () => {
        const thisToggleValue = btn.getAttribute('data-toggle');
        const isBeingDeactivated = btn.classList.contains('mixitup-control-active');
        const allChosenChoices = btn.closest('.seminar-filters__choices').querySelectorAll(".mixitup-control-active:not([data-toggle='" + thisToggleValue + "'])");
        const multipleChosen = allChosenChoices.length;
        const labelWrapper = btn.closest('.seminar-filters__dropdown').querySelector('.seminar-filters__dropdown-box');
        const labelEl = labelWrapper.querySelector('.seminar-filters__search, span');
        let label = btn.getAttribute('data-label');
        if (!label) {
            label = btn.querySelector('span').innerHTML;
        }

        if (isBeingDeactivated) {
            if (multipleChosen) {
                if (allChosenChoices.length == 1) {
                    label = allChosenChoices[0].getAttribute('data-label');
                    if (!label) {
                        label = allChosenChoices[0].querySelector('span').innerHTML;
                    }
                } else {
                    label = multipleChosenLabel;
                }

                labelEl.innerHTML = label;
                labelEl.setAttribute('placeholder', label);
            } else {
                labelEl.innerHTML = labelWrapper.getAttribute('data-label');
                labelEl.setAttribute('placeholder', labelWrapper.getAttribute('data-label'));
            }
        } else {
            if (multipleChosen) {
                label = multipleChosenLabel;
            } 
            labelEl.innerHTML = label;
            labelEl.setAttribute('placeholder', label);
        }
    });
});
}




/*
DROPDOWNS
*/

const dropdowns = document.querySelectorAll('.seminar-filters__dropdown');

[...dropdowns].forEach(dropdown => {
    const trigger = dropdown.querySelector('.seminar-filters__dropdown-box');

    dropdown.addEventListener('click', (evt) => {
        evt.stopPropagation();
    });


    trigger.addEventListener('click', () => {
        if (dropdown.classList.contains('open')) {   
            dropdown.classList.remove('open');
        } else {
            closeAllDropdowns();
            dropdown.classList.add('open');
        }
    });
});

document.addEventListener('click', () => {
    closeAllDropdowns();
});

document.onkeydown = function(evt) {
    evt = evt || window.event;
    if (evt.key == 'Escape') {
        closeAllDropdowns();
    }
};


function closeAllDropdowns() {
    [...dropdowns].forEach(dropdown => {
        dropdown.classList.remove('open');
    });
}



/*
CALENDAR
*/

const calendarCloseButton = document.querySelector('.seminar-filters__calendar-ok');
if (calendarCloseButton) {
    calendarCloseButton.addEventListener('click', () => {
        closeAllDropdowns();
    });
}

const calendarArrowButtons = document.querySelectorAll('.seminar-filters__calendar-arrow');
[...calendarArrowButtons].forEach(calendarArrowButton => {
    calendarArrowButton.addEventListener('click', () => {
        if (calendarArrowButton.classList.contains('seminar-filters__calendar-arrow--next')) {
            changeCalendarPage();
        } else {
            changeCalendarPage(true);
        }
    });
});
    
function changeCalendarPage(previous) {
    const currentPage = document.querySelector('.seminar-filters__calendar-page.show');

    let pageToShow = null;
    if (previous) {
        pageToShow = currentPage.previousSibling;
    } else {
        pageToShow = currentPage.nextSibling;
    }

    if (pageToShow) {
        pageToShow.classList.add('show');
        currentPage.classList.remove('show');
    }
}



/*
SEARCH
*/

const searchInputField = document.querySelector('.seminar-filters__search');
const lecturers = document.querySelector('.seminar-filters__choices--lecturers');

if (searchInputField && lecturers) {
    const options = lecturers.children;

    searchInputField.addEventListener('click', (evt) => {
        const dropdown = searchInputField.closest('.seminar-filters__dropdown');
        if (dropdown.classList.contains('open')) {   
            evt.stopPropagation();
        }        
    });

    searchInputField.addEventListener('keyup', () => {
        const searchInput = cleanUpStringForSearch(searchInputField.value);
        for (let i = 0; i < options.length; i++) {
            
            if (searchInput == '') {
                options[i].style.display = 'block';
            } else {
                let optionValue = cleanUpStringForSearch(options[i].querySelector('span').innerHTML);
            
                if (!optionValue.includes(searchInput)) {
                    options[i].style.display = 'none';
                } else {
                    options[i].style.display = 'block';
                } 
            }
        }
    });
}

function cleanUpStringForSearch(str) {
    return str.toLowerCase().trim().split('.').join("");
}



/*
INFO OVERLAYS
*/

const infoButtons = document.querySelectorAll('.seminar-filters__info-button');
[...infoButtons].forEach(infoButton => {
    infoButton.addEventListener('click', () => {
        const overlay = infoButton.closest('.seminar-filters__radio-wrapper').querySelector('.seminar-filters__info-overlay');
        overlay.classList.add('open');

    });
});

const infoCloseButtons = document.querySelectorAll('.seminar-filters__info-close');
[...infoCloseButtons].forEach(infoCloseButton => {
    infoCloseButton.addEventListener('click', () => {
        const overlay = infoCloseButton.closest('.seminar-filters__info-overlay');
        overlay.classList.remove('open');
    });
});

const infoOverlays = document.querySelectorAll('.seminar-filters__info-overlay');
[...infoOverlays].forEach(infoOverlay => {
    const content = infoOverlay.querySelector('.seminar-filters__info');
    content.addEventListener('click', (evt) => {
        evt.stopPropagation();
    });

    infoOverlay.addEventListener('click', () => {
        infoOverlay.classList.remove('open');
    });
});



